import React from 'react';
import { motion } from 'framer-motion';
import { Reveal } from './Reveal';
import { ShieldHeartIcon } from './icons/Icons';
export function GuaranteeSection() {
  return <section className="w-full bg-[#eaf0e5] py-16 sm:py-24" data-id="element-159" data-mp="9ucq33ejxf12">
      <div className="mx-auto max-w-4xl px-5" data-id="element-160" data-mp="9srwbg02a049">
        <Reveal data-id="element-161" data-mp="et65x2hb9i4e">
          <div className="flex flex-col items-center gap-8 rounded-3xl border-2 border-dashed border-[#698b68]/40 bg-white p-7 text-center shadow-sm sm:flex-row sm:p-10 sm:text-left" data-id="element-162" data-mp="etpomlescajh">
            <motion.div whileInView={{
            rotate: [0, -3, 3, 0]
          }} viewport={{
            amount: 0.4
          }} transition={{
            duration: 4.5,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="relative flex h-32 w-32 shrink-0 items-center justify-center rounded-full bg-[#698b68] text-white shadow-lg" data-id="element-163" data-mp="ntvyzyf6suef">
              <span className="absolute inset-2 rounded-full border-2 border-dashed border-white/45" data-id="element-164" data-mp="xls07ickl0mv" />
              <div className="relative flex flex-col items-center" data-id="element-165" data-mp="17i4p82x66qba"><ShieldHeartIcon className="h-10 w-10" strokeWidth={1.8} data-id="element-166" data-mp="17iwmdi6f0w3o" /><span className="mt-1 font-display text-xs font-black uppercase tracking-wide" data-id="element-167" data-mp="25rnk930ewsuv">30 días</span></div>
            </motion.div>
            <div data-id="element-168" data-mp="20s2jcn1omafi">
              <p className="text-xs font-extrabold uppercase tracking-[0.16em] text-[#698b68]" data-id="element-169" data-mp="20riyoyknd7xs">Inversión de riesgo total</p>
              <h2 className="mt-3 font-display text-3xl font-black text-[#29312c]" data-id="element-170" data-mp="1vvkeln6cqc36">Garantía Blindada de 30 Días</h2>
              <p className="mt-4 text-lg leading-relaxed text-[#4f5b52]" data-id="element-171" data-mp="2oi574qykcu8b">Prueba el Método GastroSmart completo por 30 días. Si no sientes un alivio real, si no notas la diferencia, te devolvemos cada centavo. Sin preguntas incómodas y sin letras chiquitas.</p>
              <p className="mt-4 font-display text-lg font-black text-[#698b68]" data-id="element-172" data-mp="2eqsie882ak6i">El único riesgo real es no intentarlo y seguir exactamente donde estás hoy.</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}